import { Select } from "@mui/material";
import { styled } from "@mui/system";

const StyledSelect = styled(Select)(({ theme }) => {
  return {
    "& .MuiInputBase-input": {
      outline: "none",
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.main,
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.palette.primary.light,
      fontSize: 14,
      padding: theme.spacing(0.5, 2.5, 0.5, 1.5),
      "&:focus": {
        borderRadius: 4,
        borderColor: theme.palette.primary.light,
      },
    },

    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: 4,
      border: "none",
      outline: "none",
    },
  };
});

export default StyledSelect;
